import { Injectable } from '@angular/core';
import { FormattingService } from '../services/formatting.service';
import { DialogSize, GaMessageService, IDialog } from '../message/ga-message.service';
import { IContact, IObject } from '../../../type_definitions/datatypes';

import * as _ from 'underscore';
import { util } from '../util';
import { ISendMailModel, SendMailComponent } from './send-mail.component';
import { IMailRequest, SendMailDataService } from './send-mail-data.service';

@Injectable()
export class SendMailService {
  protected sendMailDialog: IDialog;

  constructor(
    protected formattingService:FormattingService,
    protected messageService: GaMessageService,
    protected sendMailDataService: SendMailDataService
  ) {
    /**/
  }

  public showSendMailDialog(title?:string, subject?:string, to?:IContact[], sendFn?:(model: IMailRequest) => Promise<any>, cancelFn?:() => void): void {

    this.sendMailDialog = this.messageService.showDialog({
      component: SendMailComponent,
      inputs: {
        title: title || 'Send Mail',
        subject,
        to,
        busy: false,
        disabled: false
      },
      outputs: {
        onSave: (model: ISendMailModel): void => {
          this.setBusy(true);
          this.setDisabled(true);

          const formattedMailModel:IMailRequest = {
            to: this.formattingService.formatRecipients(model.to), // comma separated list of contact IDs + email addresses
            cc: this.formattingService.formatRecipients(model.cc), // comma separated list of contact IDs + email addresses
            bcc: this.formattingService.formatRecipients(model.bcc), // comma separated list of contact IDs + email addresses
            subject: model.subject,
            body: model.body
          };

          const sendMailFn:(model:IMailRequest) => Promise<any> = sendFn || this.sendMailDataService.sendMailToUsers;
          sendMailFn(formattedMailModel)
            .then(() => {
              this.closeDialog();
              if (!sendFn) {
                this.messageService.showFeedbackMessage('Your mail has been sent');
              }
            })
            .catch(() => {
              this.setDisabled(false);
            })
            .finally(() => {
              this.setBusy(false);
            });
        },
        onCancel: () => {
          if (cancelFn) {
            cancelFn();
          }

          this.closeDialog();
        }
      },
      wrapperComponent: false,
      size: DialogSize.LG
    });
  }

  public getSelectedContacts(rowSelection: IObject[]):IContact[] {
    const selectedContacts:IContact[] = [];

    _.each(rowSelection, (row: IObject) => {
      const contactId:number = util.extractValue(row.Deconid || row.Deconid_search);
      if (contactId) {
        selectedContacts.push({
          id: contactId,
          firstname: util.extractValue(row.Defname),
          lastname: util.extractValue(row.Delname)
        });
      }
    });

    return selectedContacts;
  }

  public closeDialog():void {
    this.sendMailDialog.hide();
  }

  protected setDisabled = (disabled:boolean):void => {
    this.sendMailDialog.content.inputs.disabled = disabled;
  };

  protected setBusy = (busy:boolean):void => {
    this.sendMailDialog.content.inputs.busy = busy;
  };
}